/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicSystemIcon extends BaseIcon {
  getChildren = () => [ <path d="M20.43,12.8H18.89L18,11.86l-1.88.74.53,1.72L15,15.57l2.1,2.11.32-.33h1.54l1.53,1.55v1.55L18.92,22H17.38l-1.53-1.55V18.9l.16-.15-2.26-2.26L12,17.82l-1.75-1.33L8,18.74l.15.15v1.55L6.62,22H5.09L3.57,20.44V18.89l1.52-1.54H6.62l.32.32L9,15.57,7.39,14.32l.55-1.79-1.85-.74-1,1H3.57L2,11.24V9.69L3.57,8.14H5.1L6.64,9.69v.7l1.75.7.76-2.46h2.08v-2L9.71,5.1V3.55L11.24,2h1.53l1.54,1.55V5.1L12.77,6.65h0v2h2.08l.78,2.53,1.73-.68V9.69l1.53-1.55h1.54L22,9.69v1.55Zm-6.74-2.59H10.31l-1,3.55L12,15.89l2.74-2.13Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 24 24'
}
